import z from 'zod';
import arrayEntry from './arrayEntry.js';
import internationalizedArraySimpleBlockContentValue from '../objects/internationalizedArraySimpleBlockContentValue.js';
var id = 'internationalizedArraySimpleBlockContent';
var fragment = {
    type: 'array',
    of: [
        {
            type: 'internationalizedArraySimpleBlockContentValue'
        }
    ]
};
var validator = z.array(internationalizedArraySimpleBlockContentValue.validator.merge(arrayEntry.validator));
export default {
    id: id,
    fragment: fragment,
    validator: validator
};

//# sourceMappingURL=internationalizedArraySimpleBlockContent.js.map